import { Button, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { EmailData } from "../App";
import Popup from "./Popup";

const APIData = ({ resData }) => {
  const [formHndler, setFormHandler] = useState({});
  const [records, setRecords] = useState("");
  const [fun, setFun] = useState();
  const [key, setKey] = useState("");
  const user = useContext(EmailData);
  const [response, setResponse] = useState("");
  const [flag, setFlag] = useState(false);
  console.log(fun);

  const handleSubmit = (e, funct) => {
    setFun("");
    e.preventDefault();
    setRecords({ body: formHndler, key, funct });
    e.target.reset();
  };
  const handleClose = () => {
    setFlag(false);
  };
  console.log(records);

  useEffect(() => {
    if (formHndler.password) {
      axios.post("/fetchAPIdetails", records).then((response) => {
        console.log(response);
        setResponse(response.data);
        setFlag(true);
        setFormHandler({});
        // formHndler.username = "";
        // formHndler.password = "";
        // formHndler.product = "";
        // formHndler.email = "";
        // formHndler.subscribed = "";  
      });
    }
  }, [records]);

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setKey(user[1]);
    setFormHandler({ ...formHndler, [name]: value });
  };
  return (
    <Wrapper>
      {resData
        ? resData.map((item, index) => {
            return (
              <Box key={index} className={index === 0 ? "Topodd" : "topEven"}>
                <Typography align="center" sx={{ my: 5 }} variant="h6">
                  {/* {item.function === "deactivate_entry"
                    ? "Deactivate Entry"
                    : "Add Single Entry"} */}
                    {item.function}
                </Typography>
                <form
                  action=""
                  className={index === 0 ? "odd" : "LowerEven"}
                  onSubmit={(event) => handleSubmit(event, item.function)}
                >
                  <Box className="alignDiv">
                    {item.parameters
                      ? item.parameters.map((ele, index) => {
                          return (
                            <Box key={index} className="innerDiv">
                              <TextField
                                id={ele}
                                label={ele}
                                variant="outlined"
                                className="textField"
                                name={ele}
                                onChange={handleInput}
                                value={formHndler.ele}
                              />
                              {/* {setData(ele)} */}
                            </Box>
                          );
                        })
                      : ""}
                  </Box>
                  <Button type="submit" variant="contained">
                    {/* {item.function === "deactivate_entry" ? "Deactivate" : "Add Entry"} */}
                    Submit
                  </Button>
                </form>

                {/* <form action="">
                  <Box className="alignDiv">
                    <TextField
                      id="outlined-basic"
                      label="Outlined"
                      variant="outlined"
                      className="textField"
                    />
                  </Box>
                </form> */}
              </Box>
            );
          })
        : ""}
      <Popup response={response} flag={flag} handleClose={handleClose} />
    </Wrapper>
  );
};

export default APIData;

const Wrapper = styled.div`
  .alignDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .alignDiv .textField {
    width: 400px;
  }
  .innerDiv {
    margin: 15px 30px;
  }

  .odd {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .odd button {
    height: 55px;
    width: 120px;
    /* margin-top: 10px; */
  }
  .LowerEven {
    text-align: center;
  }
  .LowerEven button {
    width: 120px;
    margin-top: 50px;
    height: 50px;
  }

  @media only screen and (max-width: 768px) {
    .alignDiv {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    .alignDiv .textField {
      width: 100%;
    }
    .odd button {
      margin-top: 10px;
    }
  }
`;
